import dlv from 'dlv'
import React from 'react'
import TagCloud from '../TagCloud'
import { Nav, AppConfig } from '@joehua/cms-components'
import Logo from '../Logo'

export default function LayoutContact() {
  return (
    <AppConfig>
      {({ data }) => {
        const contact = dlv(data, 'contact', {})
        const socialItems = dlv(data, 'socialItems', [])
        return (
          <div className="w-100 pv4 mw8 center mt5 mt3-l pt2 pt3-m pt0-l pb2 ph2 ph4-m">
            <Logo className="center tc w4" />
            <div className="w-100 tc">
              <Nav
                items={socialItems}
                theme={{
                  root: 'list ma0 flex items-center justify-center pl0',
                  itemWrapper: 'pa2',
                  itemLink:
                    'br-100 ba b--gray w2 h2 dib flex items-center justify-center',
                  icon: 'f4 pc',
                }}
              />
              <div className="f6 pc">{contact.address}</div>
              <div className="f6 pc">{contact.phone}</div>
              <div className="f6 pc">{contact.email}</div>
            </div>
          </div>
        )
      }}
    </AppConfig>
  )
}
